module.exports = __webpack_public_path__ + "static/media/bubble_07.3bba5ce2.jpg";